const EVENT_CATEGORIES = {
    MUSIC: 'music',
    SPORTS: 'sports',
    THEATRE: 'arts & theatre'
}

const sortEvents = events => {
    const IMAGE_TYPES = {
        CUSTOM: 'custom',
        GENERIC: 'generic'
    }

    const eventsByImageType = events.reduce((acc, event) => {
        if (event.isDateTbd || event.isTimeTbd) { return acc }
        if (!event.imageUrlRectangle) { return acc }

        const hasCustomImage = event.imageUrlRectangle.indexOf('default.') === -1

        if (hasCustomImage) {
            acc[IMAGE_TYPES.CUSTOM].push(event)
        } else {
            acc[IMAGE_TYPES.GENERIC].push(event)
        }

        return acc
    }, {
        [IMAGE_TYPES.CUSTOM]: [],
        [IMAGE_TYPES.GENERIC]: []
    })

    return eventsByImageType[IMAGE_TYPES.CUSTOM].concat(eventsByImageType[IMAGE_TYPES.GENERIC])
}

const sortEventsByCategory = eventsByCategory => {
    return Object.keys(eventsByCategory).reduce((acc, category) => {
        acc[category] = sortEvents(eventsByCategory[category])
        return acc
    }, {})
}

const Default = (eventsByCategory) => {
    const sortedEventsByCategory = sortEventsByCategory(eventsByCategory)
    return (
        sortedEventsByCategory[EVENT_CATEGORIES.SPORTS].slice(0, 2)
            .concat(
                sortedEventsByCategory[EVENT_CATEGORIES.MUSIC].slice(0, 2),
                sortedEventsByCategory[EVENT_CATEGORIES.THEATRE].slice(0, 1),
                sortedEventsByCategory[EVENT_CATEGORIES.SPORTS].slice(2),
                sortedEventsByCategory[EVENT_CATEGORIES.MUSIC].slice(2),
                sortedEventsByCategory[EVENT_CATEGORIES.THEATRE].slice(1)
            )
    )
}

const NoMusic = (eventsByCategory) => {
    const sortedEventsByCategory = sortEventsByCategory(eventsByCategory)
    return (
        sortedEventsByCategory[EVENT_CATEGORIES.SPORTS].slice(0, 3)
            .concat(
                sortedEventsByCategory[EVENT_CATEGORIES.THEATRE].slice(0, 2),
                sortedEventsByCategory[EVENT_CATEGORIES.SPORTS].slice(3),
                sortedEventsByCategory[EVENT_CATEGORIES.THEATRE].slice(2)
            )
    )
}

export default {
    Default,
    NoMusic
}
